import request from "./request"

/* 奖项列表 */
export async function lotteryGetAll(data){
    let res = await request({url:'/h5Api/lottery/getAll',method:"get",params:data})
    return res.data
}

/* 抽奖 */
export async function drawLottery(data){
    let res = await request({url:'/h5Api/lottery/drawLottery',method:"post", params: data})
    return res.data
}

/* 中奖记录 */
export async function lotteryList(data){
    let res = await request({url:'/h5Api/lottery/list',method:"get",params:data})
    return res.data
}

/* 配置信息 */
export async function controlDetail(data){
    let res = await request({url:'/h5Api/control/detail',method:"get",params:data})
    return res.data
}

/* 获取奖项分组人员 */
export async function getGroupList(data){
    let res = await request({url:'/h5Api/lottery/getGroupList',method:"post",params:data})
    return res.data
}

/* 获取自动开奖抽奖结果 */
export async function getNewRecord(data){
    let res = await request({url:'/h5Api/lottery/getNewRecord',method:"post",params:data})
    return res.data
}

/* 获取服务器时区 */
export async function serverTime(data){
    let res = await request({url:'/h5Api/control/serverTime',method:"get",params:data})
    return res.data
}

